import { Locale } from 'chaika-enums';
export const billingMachine = {
    bmHome: {
        [Locale.Ru]: 'Главная',
        [Locale.Am]: 'Գլխավոր',
        [Locale.En]: 'Home',
        [Locale.Pt]: 'Início',
        [Locale.Ge]: 'მთავარი',
    },
    bmDraftRegisters: {
        [Locale.Ru]: 'Черновики реестров',
        [Locale.Am]: 'Գրանցամատյանների նախագծեր',
        [Locale.En]: 'Register drafts',
        [Locale.Pt]: 'Rascunhos de registros',
        [Locale.Ge]: 'რეესტრების მონახაზები',
    },
    bmReadyToOnec: {
        [Locale.Ru]: 'Готовы к отправке в 1С',
        [Locale.Am]: 'Պատրաստ է առաքվել 1կ',
        [Locale.En]: 'Ready to send to 1C',
        [Locale.Pt]: 'Prontos para enviar para 1C',
        [Locale.Ge]: 'მზად 1C-ში გასაგზავნად',
    },
    bmReadyToPayors: {
        [Locale.Ru]: 'Готовы к отправке контрагентам',
        [Locale.Am]: 'Պատրաստ է ուղարկել կոնտրագենտներին',
        [Locale.En]: 'Ready to send to payors',
        [Locale.Pt]: 'Prontos para enviar aos pagadores',
        [Locale.Ge]: 'მზად კონტრაგენტებთან გასაგზავნად',
    },
    bmHeadline1: {
        [Locale.Ru]: 'С чего начнем?',
        [Locale.Am]: 'Պատրաստ է գնալ!',
        [Locale.En]: 'Where shall we start?',
        [Locale.Pt]: 'Por onde começamos?',
        [Locale.Ge]: 'საიდან დავიწყოთ?',
    },
    bmHeadline2: {
        [Locale.Ru]: 'Чем я могу помочь?',
        [Locale.Am]: 'Պատրաստ է գնալ!',
        [Locale.En]: 'How can I help?',
        [Locale.Pt]: 'Como posso ajudar?',
        [Locale.Ge]: 'რით შემიძლია დაგეხმაროთ?',
    },
    bmHeadline3: {
        [Locale.Ru]: 'Готов к работе!',
        [Locale.Am]: 'Պատրաստ է գնալ!',
        [Locale.En]: 'Ready to work!',
        [Locale.Pt]: 'Pronto para trabalhar!',
        [Locale.Ge]: 'სამუშაოდ მზად ვარ!',
    },
    bmHeadline4: {
        [Locale.Ru]: 'Готов, когда ты готов.',
        [Locale.Am]: 'Պատրաստ է գնալ!',
        [Locale.En]: "Ready when you are.",
        [Locale.Pt]: 'Pronto quando você estiver.',
        [Locale.Ge]: 'მზად ვარ, როცა შენ მზად იქნები.',
    },
    bmSomethingWentWrong: {
        [Locale.Ru]: 'Что-то пошло не так',
        [Locale.Am]: 'Ինչ-որ բան այն չէ',
        [Locale.En]: 'Something went wrong',
        [Locale.Pt]: 'Algo deu errado',
        [Locale.Ge]: 'რაღაც არასწორად წავიდა',
    },
    bmRegistersList: {
        [Locale.Ru]: 'Список реестров',
        [Locale.Am]: 'Ռեեստրների ցանկ',
        [Locale.En]: 'Registers list',
        [Locale.Pt]: 'Lista de registros',
        [Locale.Ge]: 'რეესტრების სია',
    },
    bmDeleteRegisters: {
        [Locale.Ru]: 'Удалить реестры',
        [Locale.Am]: 'Ջնջել գրանցամատյանները',
        [Locale.En]: 'Delete registers',
        [Locale.Pt]: 'Excluir registros',
        [Locale.Ge]: 'რეესტრების წაშლა',
    },
    bmAllClinicsMoscowCity: {
        [Locale.Ru]: 'Все клиники (Москва-Сити)',
        [Locale.Am]: 'Բոլոր կլինիկաները (Մոսկվա Սիթի)',
        [Locale.En]: 'All clinics (Moscow City)',
        [Locale.Pt]: 'Todas as clínicas (Moscow City)',
        [Locale.Ge]: 'ყველა კლინიკა (მოსკოვ-სიტი)',
    },
    bmPayor: {
        [Locale.Ru]: 'Плательщик',
        [Locale.Am]: 'Վճարող',
        [Locale.En]: 'Payor',
        [Locale.Pt]: 'Pagador',
        [Locale.Ge]: 'გადამხდელი',
    },
    bmClinics: {
        [Locale.Ru]: 'Клиники',
        [Locale.Am]: 'Կլինիկաներ',
        [Locale.En]: 'Clinics',
        [Locale.Pt]: 'Clínicas',
        [Locale.Ge]: 'კლინიკები',
    },
    bmDateFromShort: {
        [Locale.Ru]: 'С',
        [Locale.Am]: 'Ս',
        [Locale.En]: 'From',
        [Locale.Pt]: 'De',
        [Locale.Ge]: 'დან',
    },
    bmDateToShort: {
        [Locale.Ru]: 'По',
        [Locale.Am]: 'Ըստ',
        [Locale.En]: 'To',
        [Locale.Pt]: 'Até',
        [Locale.Ge]: 'მდე',
    },
    bmPatientFullName: {
        [Locale.Ru]: 'ФИО пациента',
        [Locale.Am]: 'Պացիենտ',
        [Locale.En]: "Patient's full name",
        [Locale.Pt]: 'Nome completo do paciente',
        [Locale.Ge]: 'პაციენტის სრული სახელი',
    },
    bmTotalServices: {
        [Locale.Ru]: 'Всего услуг:',
        [Locale.Am]: 'Ընդամենը ծառայություններ:',
        [Locale.En]: 'Total services:',
        [Locale.Pt]: 'Total de serviços:',
        [Locale.Ge]: 'სულ სერვისები:',
    },
    bmLoading: {
        [Locale.Ru]: 'Загрузка...',
        [Locale.Am]: 'Բեռնում...',
        [Locale.En]: 'Loading...',
        [Locale.Pt]: 'Carregando...',
        [Locale.Ge]: 'იტვირთება...',
    },
    bmNoServicesFound: {
        [Locale.Ru]: 'Услуги не найдены',
        [Locale.Am]: 'Ծառայություններ չեն գտնվել',
        [Locale.En]: 'No services found',
        [Locale.Pt]: 'Nenhum serviço encontrado',
        [Locale.Ge]: 'სერვისები ვერ მოიძებნა',
    },
    bmBackToRegistersList: {
        [Locale.Ru]: 'К списку реестров',
        [Locale.Am]: 'Գրանցամատյանների ցանկին',
        [Locale.En]: 'Back to registers list',
        [Locale.Pt]: 'Voltar para a lista de registros',
        [Locale.Ge]: 'რეესტრების სიაში დაბრუნება',
    },
    bmCreateDraftRegisters: {
        [Locale.Ru]: 'Создать черновики реестров',
        [Locale.Am]: 'Ստեղծեք գրանցամատյանների նախագծեր',
        [Locale.En]: 'Create register drafts',
        [Locale.Pt]: 'Criar rascunhos de registros',
        [Locale.Ge]: 'რეესტრების მონახაზების შექმნა',
    },
    bmExportRegistersToExcel: {
        [Locale.Ru]: 'Сформировать реестры в Excel',
        [Locale.Am]: 'Ստեղծեք գրանցամատյաններ Excel-ում',
        [Locale.En]: 'Export registers to Excel',
        [Locale.Pt]: 'Exportar registros para Excel',
        [Locale.Ge]: 'რეესტრების Excel-ში ექსპორტი',
    },
    bmViewServices: {
        [Locale.Ru]: 'Посмотреть услуги',
        [Locale.Am]: 'Դիտել ծառայությունները',
        [Locale.En]: 'View services',
        [Locale.Pt]: 'Ver serviços',
        [Locale.Ge]: 'სერვისების ნახვა',
    },
    bmWithoutLegalEntitySplit: {
        [Locale.Ru]: 'Без разбиения на юр.лица',
        [Locale.Am]: 'Առանց Յուրայի բաժանման:դեմքեր',
        [Locale.En]: 'Without splitting by legal entity',
        [Locale.Pt]: 'Sem divisão por entidade jurídica',
        [Locale.Ge]: 'იურიდიული პირების მიხედვით დაყოფის გარეშე',
    },
    bmSplitByAllLegalEntities: {
        [Locale.Ru]: 'Разбиение на все юр.лица',
        [Locale.Am]: 'Բաժանում ամեն ինչի յուր.դեմքեր',
        [Locale.En]: 'Split by all legal entities',
        [Locale.Pt]: 'Dividir por todas as entidades jurídicas',
        [Locale.Ge]: 'ყველა იურიდიული პირის მიხედვით დაყოფა',
    },
    bmSelectPayors: {
        [Locale.Ru]: 'Выберите контрагентов',
        [Locale.Am]: 'Ընտրեք գործընկերներ',
        [Locale.En]: 'Select payors',
        [Locale.Pt]: 'Selecione os pagadores',
        [Locale.Ge]: 'აირჩიეთ კონტრაგენტები',
    },
    bmSelectAll: {
        [Locale.Ru]: 'Выбрать всех',
        [Locale.Am]: 'Ընտրել բոլորը',
        [Locale.En]: 'Select all',
        [Locale.Pt]: 'Selecionar todos',
        [Locale.Ge]: 'ყველას არჩევა',
    },
    bmSelectClinics: {
        [Locale.Ru]: 'Выберите клиники',
        [Locale.Am]: 'Ընտրեք Կլինիկաներ',
        [Locale.En]: 'Select clinics',
        [Locale.Pt]: 'Selecione as clínicas',
        [Locale.Ge]: 'აირჩიეთ კლინიკები',
    },
    bmCreateRegisters: {
        [Locale.Ru]: 'Создать реестры',
        [Locale.Am]: 'Ստեղծել գրանցամատյաններ',
        [Locale.En]: 'Create registers',
        [Locale.Pt]: 'Criar registros',
        [Locale.Ge]: 'რეესტრების შექმნა',
    },
    bmSendToOnecResult: {
        [Locale.Ru]: 'Результат отправки в 1С',
        [Locale.Am]: '1C ուղարկելու արդյունք',
        [Locale.En]: 'Send to 1C result',
        [Locale.Pt]: 'Resultado do envio para 1C',
        [Locale.Ge]: '1C-ში გაგზავნის შედეგი',
    },
    bmSuccess: {
        [Locale.Ru]: 'Успех',
        [Locale.Am]: 'Հաջողություն',
        [Locale.En]: 'Success',
        [Locale.Pt]: 'Sucesso',
        [Locale.Ge]: 'წარმატება',
    },
    bmReadyToOnecTitle: {
        [Locale.Ru]: 'Готовые к отправке в 1С',
        [Locale.Am]: 'Պատրաստ է առաքման 1C',
        [Locale.En]: 'Ready to send to 1C',
        [Locale.Pt]: 'Prontos para enviar para 1C',
        [Locale.Ge]: 'მზად 1C-ში გასაგზავნად',
    },
    bmSendToOnec: {
        [Locale.Ru]: 'Отправить в 1С',
        [Locale.Am]: 'Ուղարկել 1կ',
        [Locale.En]: 'Send to 1C',
        [Locale.Pt]: 'Enviar para 1C',
        [Locale.Ge]: '1C-ში გაგზავნა',
    },
    bmSendToEmailResult: {
        [Locale.Ru]: 'Результат отправки на почту',
        [Locale.Am]: 'Էլ. փոստով ուղարկելու արդյունք',
        [Locale.En]: 'Email sending result',
        [Locale.Pt]: 'Resultado do envio por e-mail',
        [Locale.Ge]: 'ფოსტით გაგზავნის შედეგი',
    },
    bmReadyToPayorsTitle: {
        [Locale.Ru]: 'Готовые к отправке контрагентам',
        [Locale.Am]: 'Կոնտրագենտներին ուղարկելու համար պատրաստները',
        [Locale.En]: 'Ready to send to payors',
        [Locale.Pt]: 'Prontos para enviar aos pagadores',
        [Locale.Ge]: 'მზად კონტრაგენტებთან გასაგზავნად',
    },
    bmSendToPayors: {
        [Locale.Ru]: 'Отправить контрагентам',
        [Locale.Am]: 'Ուղարկել կոնտրագենտներին',
        [Locale.En]: 'Send to payors',
        [Locale.Pt]: 'Enviar aos pagadores',
        [Locale.Ge]: 'კონტრაგენტებთან გაგზავნა',
    },
    bmSentToPayors: {
        [Locale.Ru]: 'Отправлено контрагентам',
        [Locale.Am]: 'Ուղարկվել է կոնտրագենտներին',
        [Locale.En]: 'Sent to payors',
        [Locale.Pt]: 'Enviado aos pagadores',
        [Locale.Ge]: 'გაგზავნილია კონტრაგენტებთან',
    },
    bmExportSummaryReport: {
        [Locale.Ru]: 'Сформировать сводный отчет',
        [Locale.Am]: 'Ձևավորել ամփոփ հաշվետվություն',
        [Locale.En]: 'Generate summary report',
        [Locale.Pt]: 'Gerar relatório resumido',
        [Locale.Ge]: 'შემაჯამებელი ანგარიშის შექმნა',
    },
};
